import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Recent Activity',
  actions: {
    clicked: 'Clicked',
    open: 'Opened',
    scheduled: 'Scheduled',
    sent: 'Sent',
  },
  fields: {
    recipients: '{{recipients}} Recipients',
    opened: '{{rate}} Opened',
    clicked: '{{rate}} Clicked',
    awaiting: 'Awaiting confirmation',
  },
  template_types: TemplateNames,
};
